import { paramCase } from '@client/common/utils/string/string';
import { ManufacturerType } from '@client/manufacturer/redux/manufacturers/types';
import { ROUTES } from '@client/routes/components/Router/routes';
import { useUrlCreator } from '@client/routes/hooks';

export const useGenerateManufacturerUrl = (): (manufacturer: ManufacturerType) => string => {
  const urlCreator = useUrlCreator();

  return (manufacturer: ManufacturerType): string => {
    const manufacturerLink = paramCase(
      `${manufacturer.name} ${manufacturer.category} ${manufacturer.manufacturerId}`,
    );

    return urlCreator(
      ROUTES.manufacturer,
      { manufacturer: manufacturerLink },
    );
  };
};
